import { useBreakpointValue } from '@vimeo/bokeh';
import { useGetAlbumVideos } from '@vimeo/gctl-api/hooks/useAlbumVideos';

import { useGetShowcase } from './use-get-showcase';
import { useSelectedId } from './use-selected-id';
import { useAlbumStore } from '../state/albumStore';
import { ITEMS_PER_PAGE, ITEMS_PER_PAGE_MOBILE, VIDEOS_API_VERSION } from '../utils/constants';

/** Sets the page number of the page of album videos that contains the passed clipId to album store */
export const useGetDeeplinkedVideoPage = () => {
  const { selectedId } = useSelectedId();

  const perPage = useBreakpointValue(
    { base: ITEMS_PER_PAGE_MOBILE, lg: ITEMS_PER_PAGE },
    { ssr: false },
  );

  const { albumId, password, isShowcaseEmbedded, clipPlaylistPage, setClipPlaylistPage, referrer } =
    useAlbumStore((state) => ({
      albumId: state.albumId,
      password: state.hashedPass,
      isShowcaseEmbedded: state.isShowcaseEmbedded,
      clipPlaylistPage: state.clipPlaylistPage,
      setClipPlaylistPage: state.setClipPlaylistPage,
      referrer: state.referrer,
    }));

  const embedQuery = {
    isEmbed: isShowcaseEmbedded,
    referrer,
  };

  const { sortConfig } = useGetShowcase();

  const { data, error, ...gctlConfig } = useGetAlbumVideos(
    () => {
      // Only run on first load so once deeplinkPage is set to global store return
      // We don't want to run on subsequent changes of the clipId
      if (!selectedId || clipPlaylistPage) return null;

      return {
        where: { albumId },
        select: ['uri'],
        query: {
          perPage,
          containingUri: `/videos/${selectedId}`,
          forceCollectionUri: true,
          ...embedQuery,
          ...sortConfig,
          ...(password && { password }),
        },
        headers: { Accept: `application/vnd.vimeo.*+json;version=${VIDEOS_API_VERSION}` },
      };
    },
    {
      revalidateOnFocus: false,
      onSuccess: (data) => {
        // Set page number to album store so it doesn't get nulled when the query returns early
        setClipPlaylistPage(data.page);
      },
    },
  );
};
